import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, signal, SimpleChanges } from '@angular/core';
import { Map, View } from 'ol';
import { transform } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import MapConstants from '../../carte/constants';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { Tir } from 'src/app/bo/tir';
import { FonctionsService } from 'src/app/services/fonctions-partagees.service';
import { HttpService } from 'src/app/services/http.service';
import { Fichier } from 'src/app/bo/fichier';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { RapportCreationModaleComponent } from '../../rapport-creation-modale/rapport-creation-modale.component';
import { TypeTir } from 'src/app/bo/TypeTir';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TirModaleComponent } from '../../tir-modale/tir-modale.component';
import { Router } from '@angular/router';
import { Zone } from '../../../bo/zone';
import { Site } from 'src/app/bo/site';
import { BlastService } from 'src/app/services/blast.service';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { BlastedStatusModalComponent } from '../../blasted-status-modal/blasted-status-modal.component';

@Component({
  selector: 'app-tir-info',
  templateUrl: './tir-info.component.html',
  styleUrls: ['./tir-info.component.scss'],
  standalone: false
})
export class TirInfoComponent implements OnInit, OnChanges {
  @Input() tir: Tir;
  @Output() suppTir = new EventEmitter<any>();
  @Output() modifTir = new EventEmitter<Tir>();

  site: Site;
  ngOnChanges(changes: SimpleChanges): void {
      if (changes['tir']) {
        this.isBlasted = this.tir?.blasted == 1;
      }
  }
  
  modaleCreateRapport: BsModalRef;
  modaleAjout: BsModalRef;
  isBlasted = false;
  map: Map;

  constructor(
    protected userService: UtilisateurService,
    private readonly fonctionsService: FonctionsService,
    private readonly http: HttpService,
    private readonly modalService: BsModalService,
    private readonly router: Router,
    private readonly blastService: BlastService,
    private readonly dialogConfirme: MatDialog,
    private readonly cdr: ChangeDetectorRef,
    private readonly cookieService: CookieService
  ) {
   }

  get timeFormat(): string {
    const lang = this.cookieService.get('epcLanguage') || 'en';
    return lang === 'fr' ? 'HH:mm' : 'hh:mm a';
  }

  ngOnInit(): void {
    this.initMap();
  }

  private initMap() {

    this.isBlasted = this.tir?.blasted == 1;
    let center = MapConstants.DEFAULT_CENTER;
    let zoom = MapConstants.DEFAULT_ZOOM_LEVEL;

    this.http.get<Site>('Sites/' + this.userService.currentSite()?.siteId)
      .pipe(
        switchMap(site => {
          this.site = site;
          return this.http.get<string>('Sites/proj4/' + this.site.epsg);
        })
      )
      .subscribe(proj4String => {
        if (this.site.coordX !== undefined && this.site.coordY !== undefined && this.site.epsg) {
          const coordSite = [this.site.coordX, this.site.coordY];
          const epsgCode = 'EPSG:' + this.site.epsg;
          this.registerProjString(proj4String);
          center = transform(coordSite, epsgCode, MapConstants.EPSG_REFERENCE_OL);

          this.map = new Map({
            target: 'map',
            interactions: [],
            controls: [],
            layers: [
              new TileLayer({
                source: new OSM(),
              }),
            ],
            view: new View({
              center: center,
              zoom: zoom,
              constrainResolution: true
            }),
          });
        }
      });
  }
  registerProjString(projString: string) {
    if (undefined !== projString && null !== projString && projString != "") {
      proj4.defs("EPSG:" + this.site.epsg, projString);
      register(proj4);
    }
  }
creerRapport() {
    this.fonctionsService.loading_screen(true);
    this.http.get<Fichier[]>('Sites/' + this.userService.currentSite()?.siteId + '/Templates')
      .subscribe(fichiers => {
        this.fonctionsService.loading_screen(false);
        if (undefined !== this.tir) {
          const initialState = {
            templates: signal(fichiers),
            tir: signal(this.tir),
            siteId: signal(this.userService.currentSite()?.siteId)
          }
          this.modaleCreateRapport = this.modalService.show(RapportCreationModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, initialState });
        }
      },
        error => this.fonctionsService.loading_screen(false)
      );
  }

  ouvrirModaleModif() {
      this.fonctionsService.loading_screen(true);
  
      let tir = this.http.get<Tir>('Blasts/' + this.tir.tirId);
      let zones = this.http.get<Zone[]>('Sites/' + this.userService.currentSite()?.siteId + '/Zones');
      let typeTirs = this.http.get<TypeTir[]>('Sites/' + this.userService.currentSite()?.siteId + '/BlastTypes');

      forkJoin([tir, zones, typeTirs]).subscribe(resultats => {
        this.fonctionsService.loading_screen(false);
        let tirActif = resultats[0];
        tirActif.dateTirPrevisionnelle = new Date(tirActif.dateTirPrevisionnelle);
        if (tirActif.dateTirEffective)
          tirActif.dateTirEffective = new Date(tirActif.dateTirEffective);
  
        const initialState = {
          tabZones: resultats[1],
          tabTypeTirs: resultats[2],
          zoneSelectionnee: resultats[1].find(o => o.zoneId == this.tir.zoneId),
          typeTirSelectionne: resultats[2].find(o => o.typeTirId == tirActif.typeTirId),
          estModif: true,
          niveauTir: tirActif.niveau,
          tir: tirActif
        };
        this.modaleAjout = this.modalService.show(TirModaleComponent,
          {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            class: 'modal-lg',
            animated: false,
            initialState: initialState as Partial<TirModaleComponent>
          });
        this.modaleAjout.content.modifTir.subscribe(tir => {
          // Suppression
          if (tir == null) {
            this.suppTir.emit();
            this.router.navigate(['mysite', this.userService.currentSite()?.siteId, 'myprojects', this.userService.currentProjet.projetId]);
          } else {
            this.tir = tir;
            this.modifTir.emit(tir);
          }
          this.isBlasted = tir.blasted === 1;
        });
      }, () => { this.fonctionsService.loading_screen(false) });
    }

    navigateToSite() {
      this.router.navigate(['mysite', this.userService.currentSite()?.siteId], {
          queryParams: { blastId: this.tir?.tirId }
        });
    }


    protected handleBlastedClick(event: Event) {
      event.preventDefault();
      if (this.tir.blasted !== 1) {
        this.updateBlastedStatus();
        return;
      }

      this.blastService.markAsBlasted(this.tir.tirId, new Date(), false).subscribe({
        next: (tir) => {
          this.tir.blasted = tir.blasted;
          this.tir.dateTirEffective = tir.dateTirEffective;
          this.isBlasted = this.tir.blasted === 1;
          this.modifTir.emit(this.tir);
          this.cdr.detectChanges();
        }
      });
    }

    protected updateBlastedStatus() {
      const dialogRef = this.dialogConfirme.open(BlastedStatusModalComponent,
        {
          data: { blast: this.tir }
        },
      );
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.tir.blasted = result.blasted;
          this.tir.dateTirEffective = result.dateTirEffective;
          this.isBlasted = this.tir.blasted === 1;
          this.modifTir.emit(this.tir);
          this.cdr.detectChanges();
        }
      });
    }
}